import { defaultValues, UserFormContextProvider } from '../utils/userFormContext'
import { defaultUserErrorValues, UserFormErrorContextProvider } from '../utils/userFormErrorContext'
import RequiredExpertForm from './RequiredExpertForm'
import { emptyData } from '../userFormData'

const RequiredExpertCreation = () => (
    <UserFormContextProvider initialValues={defaultValues}>
        <UserFormErrorContextProvider initialValues={defaultUserErrorValues}>
            <RequiredExpertForm mode="CREATION" data={emptyData} />
        </UserFormErrorContextProvider>
    </UserFormContextProvider>
)

export default RequiredExpertCreation
